var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-Input',{directives:[{name:"currency",rawName:"v-currency",value:(_vm.options),expression:"options"}],ref:"input",attrs:{"value":_vm.formattedValue},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }